import { getCountryCodeForRegionCode, parsePhoneNumber } from 'awesome-phonenumber';

import { store } from 'utils/configureStore';

const getTapPaymentUserPhone = (phoneProp) => {
	const { phone: userPhone } = store.getState().user;

	const phone = phoneProp || userPhone;

	const phoneNumber = parsePhoneNumber(!phone?.startsWith('+') ? `+${phone}` : phone);
	const countryCode = getCountryCodeForRegionCode(phoneNumber.regionCode)?.toString();
	return {
		phone: phoneNumber.number.significant,
		countryCode
	};
};

export default getTapPaymentUserPhone;
